module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/tn-8b09464a7524dff3fa47e5a0204991e5.svg";